var AppAjsController = /** @class */ (function () {
    /*@ngInject*/
    function AppAjsController($rootScope, $timeout, $state, authService, StorageService, utilityService, MESSAGECONSTANTS, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$state = $state;
        this.authService = authService;
        this.StorageService = StorageService;
        this.utilityService = utilityService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    AppAjsController.prototype.$onInit = function () {
        var _this = this;
        this.listenToToggleHeaderDisplay();
        this.cleanUpLogoutMeeting = this.$rootScope.$on("logoutFromMeeting", function () {
            _this.userActive = false;
            _this.showHeaderNav = true;
            _this.$timeout(function () {
                _this._logoutAndRedirectUser(true);
            }, 1000);
        });
    };
    AppAjsController.prototype.listenToToggleHeaderDisplay = function () {
        var _this = this;
        this.utilityService.receiveToggleHeaderNavDisplay().then(null, null, function (display) {
            _this.showHeaderNav = display;
        });
    };
    AppAjsController.prototype._logoutAndRedirectUser = function (redirectFlag) {
        var _this = this;
        var rememberMeStatus = angular.copy(this.StorageService.getCookie('rememberme'));
        var userDetails = angular.copy(this.StorageService.get('userDetails'));
        this.StorageService.resetBrowserStorage();
        if (angular.isDefined(rememberMeStatus) && (rememberMeStatus !== null) && (rememberMeStatus === true)) {
            if (angular.isDefined(userDetails) && (userDetails !== null)) {
                this.StorageService.setCookie('logoutemail', userDetails.emailId);
            }
        }
        this.authService.logout(function (data) {
            _this.StorageService.removeCookie('connect.sid');
            _this.StorageService.remove('companyDetails');
            _this.StorageService.remove('SelectedHostCompany');
            _this.StorageService.remove('userDetails');
            _this.$state.go('exitMeeting', null, { reload: true });
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    AppAjsController.prototype.$onDestroy = function () {
        if (this.cleanUpLogoutMeeting) {
            this.cleanUpLogoutMeeting();
        }
    };
    return AppAjsController;
}());
AppAjsController.$inject = ['$rootScope', '$timeout', '$state', 'authService', 'StorageService', 'utilityService', 'MESSAGECONSTANTS', 'alertsAndNotificationsService'];
// const html = require('!raw-loader!./app.component.html');
// @ts-ignore
import * as TEMPLATE from 'raw-loader!./app.component.ajs.html';
export var AppAjsComponent = {
    selector: 'appAjs',
    component: {
        bindings: {
            userActive: '=',
            disableScreen: '=',
            appLoaded: '=',
            showHeaderNav: '='
        },
        controller: AppAjsController,
        // templateUrl: "./app.component.ajs.html"
        template: TEMPLATE.default
        // app.ajs.html'
    }
};
//# sourceMappingURL=app.component.ajs.js.map